import React, { useState } from "react";
import Contact from "../contact";
import arrowIcon from "../../images/home/arrow-icon.svg";
import ellipticalIcon from "../../images/individual/ellipticalIcon.svg";
import rightVector from "../../images/individual/right-vector.svg";
import benifitIcon from "../../images/individual/benifitIcon.png";
import { FaPassport, FaCheckCircle, FaClock, FaUsers, FaHome, FaHeart, FaGraduationCap, FaBriefcase, FaMedkit, FaStar, FaQuestionCircle, FaPhone, FaMapMarkerAlt, FaFlag, FaShieldAlt } from "react-icons/fa";
import { Helmet } from "react-helmet-async";
import Testimonials from "../Testimonials";

const NZAustraliaVisa = () => {
  const [activeVisa, setActiveVisa] = useState('189');
  const [activeFAQ, setActiveFAQ] = useState(null);

  const visaOptions = [
    {
      id: '189',
      title: 'Skilled Independent Visa (Subclass 189)',
      subtitle: 'New Zealand Stream',
      description: 'For NZ citizens who have lived in Australia long-term and want permanent residency (PR).',
      icon: FaPassport,
      processing: '12-24 months',
      prPathway: true,
      bestFor: 'NZ citizens wanting permanent residency'
    },
    {
      id: '444',
      title: 'Special Category Visa (Subclass 444)',
      subtitle: 'Temporary Residence',
      description: 'Automatic visa granted on arrival for NZ citizens.',
      icon: FaFlag,
      processing: 'Instant on arrival',
      prPathway: false,
      bestFor: 'NZ citizens wanting flexible work rights'
    },
    {
      id: '461',
      title: 'Family Member Visa (Subclass 461)',
      subtitle: 'For Non-NZ Family Members',
      description: 'For partners/dependents of NZ citizens living in Australia on an SCV (444).',
      icon: FaUsers,
      processing: '6-12 months',
      prPathway: false,
      bestFor: 'Family members of NZ citizens'
    }
  ];

  const faqs = [
    {
      question: "Can I get Australian citizenship as an NZ citizen?",
      answer: "Yes, if you qualify for PR first (e.g., via Subclass 189 NZ Stream)."
    },
    {
      question: "Does the Subclass 444 visa expire?",
      answer: "No, but you must re-enter Australia every 5 years to keep it active."
    },
    {
      question: "Can my non-NZ partner join me in Australia?",
      answer: "Yes, they can apply for the Subclass 461 visa."
    },
    {
      question: "How long does the Subclass 189 (NZ Stream) take?",
      answer: "Typically 12-24 months, depending on documentation."
    }
  ];

  const getVisaContent = (visaId) => {
    switch(visaId) {
      case '189':
        return (
          <div className="space-y-6">
            <div className="bg-green-50 p-6 rounded-lg">
              <h4 className="text-lg font-semibold text-blue mb-4 flex items-center gap-2">
                <FaCheckCircle className="text-green-600" />
                Eligibility Requirements:
              </h4>
              <ul className="space-y-2 text-blue">
                <li className="flex items-start gap-2">
                  <span className="text-green-600 mt-1">•</span>
                  Hold a Special Category Visa (SCV - Subclass 444)
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-600 mt-1">•</span>
                  Have lived in Australia for at least 5 years (since Feb 2016)
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-600 mt-1">•</span>
                  Meet income threshold (AUD $53,900 per year for 4 years)
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-600 mt-1">•</span>
                  Pass health & character checks
                </li>
              </ul>
            </div>
            
            <div className="bg-blue-50 p-6 rounded-lg">
              <h4 className="text-lg font-semibold text-blue mb-4 flex items-center gap-2">
                <FaStar className="text-blue" />
                Benefits:
              </h4>
              <ul className="space-y-2 text-blue">
                <li className="flex items-start gap-2">
                  <span className="text-blue mt-1">•</span>
                  Permanent residency with full work & study rights
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-blue mt-1">•</span>
                  Access to Medicare & social benefits
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-blue mt-1">•</span>
                  Pathway to citizenship
                </li>
              </ul>
            </div>
          </div>
        );
      
      case '444':
        return (
          <div className="space-y-6">
            <div className="bg-green-50 p-6 rounded-lg">
              <h4 className="text-lg font-semibold text-blue mb-4 flex items-center gap-2">
                <FaCheckCircle className="text-green-600" />
                Eligibility:
              </h4>
              <ul className="space-y-2 text-blue">
                <li className="flex items-start gap-2">
                  <span className="text-green-600 mt-1">•</span>
                  Hold a valid NZ passport
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-600 mt-1">•</span>
                  No criminal record or health risks
                </li>
              </ul>
            </div>
            
            <div className="bg-blue-50 p-6 rounded-lg">
              <h4 className="text-lg font-semibold text-blue mb-4 flex items-center gap-2">
                <FaStar className="text-blue" />
                Benefits:
              </h4>
              <ul className="space-y-2 text-blue">
                <li className="flex items-start gap-2">
                  <span className="text-blue mt-1">•</span>
                  Live, work, and study in Australia indefinitely (but not permanent residency)
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-blue mt-1">•</span>
                  No application needed (granted at airport)
                </li>
              </ul>
            </div>

            <div className="bg-yellow-50 p-6 rounded-lg border-l-4 border-yellow-400">
              <h4 className="text-lg font-semibold text-blue mb-4 flex items-center gap-2">
                ⚠ Limitations:
              </h4>
              <ul className="space-y-2 text-blue">
                <li className="flex items-start gap-2">
                  <span className="text-yellow-600 mt-1">•</span>
                  No access to some welfare benefits
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-yellow-600 mt-1">•</span>
                  Must apply for a different visa for PR pathway
                </li>
              </ul>
            </div>
          </div>
        );
      
      case '461':
        return (
          <div className="space-y-6">
            <div className="bg-green-50 p-6 rounded-lg">
              <h4 className="text-lg font-semibold text-blue mb-4 flex items-center gap-2">
                <FaCheckCircle className="text-green-600" />
                Eligibility:
              </h4>
              <ul className="space-y-2 text-blue">
                <li className="flex items-start gap-2">
                  <span className="text-green-600 mt-1">•</span>
                  Be a family member (spouse, de facto partner, or dependent child) of an NZ citizen holding an SCV
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-600 mt-1">•</span>
                  Not be an NZ citizen yourself
                </li>
              </ul>
            </div>
            
            <div className="bg-blue-50 p-6 rounded-lg">
              <h4 className="text-lg font-semibold text-blue mb-4 flex items-center gap-2">
                <FaStar className="text-blue" />
                Benefits:
              </h4>
              <ul className="space-y-2 text-blue">
                <li className="flex items-start gap-2">
                  <span className="text-blue mt-1">•</span>
                  5-year temporary visa (renewable)
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-blue mt-1">•</span>
                  Full work & study rights
                </li>
              </ul>
            </div>
          </div>
        );
      
      default:
        return null;
    }
  };

  return (
    <div>
      <Helmet>
        <title>New Zealand to Australia Visa (Subclass 189, 461, 444) - NZ Citizens Migration - Immiget Global</title>
        <meta
          name="description"
          content="NZ citizens moving to Australia? Expert guidance on Subclass 189 NZ Stream, 444 SCV & 461 Family visas. Permanent residency pathways for New Zealanders."
        />
        <meta 
          name="keywords" 
          content="new zealand to australia visa, subclass 189 nz stream, subclass 444 visa, subclass 461 visa, nz citizens australia, permanent residency australia, SCV visa" 
        />
      </Helmet>
      
      <div className="w-full h-90 font-Hellix bg-cover bg-center bg-image">
        <div className="max-w-[1440px] px-4 md:px-[75px] m-auto h-full">
          <div className="flex flex-col gap-2 md:gap-2 pt-10 md:pt-20 pb-[90px] h-full justify-center">
            <div className="text-white hellix-font text-center font-semibold text-[22px] md:text-[54px]">
              New Zealand to Australia Visa Pathways
            </div>
            <div className="text-white hellix-font text-center font-medium text-[14px] md:text-[18px] mb-4">
              Subclass 189, 461, 444 – Live & Work in Australia
            </div>
            <div className="flex justify-center gap-2 md:gap-4">
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium">
                HOME
              </div>
              <div className="flex items-center">
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
              </div>
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium uppercase">
                NZ to Australia Visas
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Introduction Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="text-center">
          <h1 className="xl:text-[30px] text-[24px] text-blue font-semibold hellix-font mb-4">
            Are You a New Zealander Looking to Move to Australia?
          </h1>
          <p className="hellix-font text-blue text-lg xl:text-[20px] font-normal max-w-4xl mx-auto">
            Whether you're seeking permanent residency, family sponsorship, or work rights, Australia offers multiple visa options for Kiwis. At Immiget Global, we specialize in helping New Zealanders navigate the visa process smoothly, ensuring a seamless transition to life in Australia.
          </p>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Visa Options Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2 mb-6">
          <div className="flex items-center">
            <img src={benifitIcon} alt="benefits" />
          </div>
          <h2 className="lg:text-[28px] text-2xl text-blue font-semibold hellix-font">
            Visa Options for New Zealanders Moving to Australia
          </h2>
        </div>

        {/* Visa Selection Tabs */}
        <div className="flex flex-wrap gap-3 mb-8">
          {visaOptions.map((visa) => {
            const IconComponent = visa.icon;
            return (
              <button
                key={visa.id}
                onClick={() => setActiveVisa(visa.id)}
                className={`flex items-center gap-2 px-4 py-3 rounded-lg font-medium hellix-font transition-all duration-300 ${
                  activeVisa === visa.id
                    ? 'bg-blue text-white shadow-lg'
                    : 'bg-gray-100 text-blue hover:bg-blue-50'
                }`}
              >
                <IconComponent className="text-lg" />
                Subclass {visa.id}
              </button>
            );
          })}
        </div>

        {/* Active Visa Content */}
        {visaOptions.map((visa) => {
          if (activeVisa !== visa.id) return null;
          const IconComponent = visa.icon;
          
          return (
            <div key={visa.id} className="bg-white rounded-lg shadow-custom-white p-6 lg:p-8">
              <div className="flex items-start gap-4 mb-6">
                <div className="bg-blue text-white p-4 rounded-full flex-shrink-0">
                  <IconComponent className="text-2xl" />
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl lg:text-3xl text-blue font-bold hellix-font mb-2">
                    {visa.title}
                  </h3>
                  <p className="text-blue text-lg font-medium hellix-font mb-2">
                    {visa.subtitle}
                  </p>
                  <p className="text-blue hellix-font text-lg leading-relaxed">
                    {visa.description}
                  </p>
                  
                  <div className="flex flex-wrap gap-4 mt-4">
                    <div className="flex items-center gap-2 bg-blue-50 px-3 py-2 rounded-lg">
                      <FaClock className="text-blue text-sm" />
                      <span className="text-blue text-sm font-medium hellix-font">
                        Processing: {visa.processing}
                      </span>
                    </div>
                    <div className={`flex items-center gap-2 px-3 py-2 rounded-lg ${
                      visa.prPathway ? 'bg-green-50 text-green-700' : 'bg-yellow-50 text-yellow-700'
                    }`}>
                      <span className="text-sm font-medium hellix-font">
                        PR Pathway: {visa.prPathway ? '✅ Yes' : '❌ No (temporary)'}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              
              {getVisaContent(visa.id)}
            </div>
          );
        })}
      </div>

      {/* Comparison Table */}
      <div className="container max-w-1440px mx-auto px-4 py-6 lg:px-14">
        <h2 className="text-2xl lg:text-3xl text-blue font-bold hellix-font mb-6 text-center">
          Which Visa is Right for You?
        </h2>
        
        <div className="overflow-x-auto">
          <table className="w-full bg-white rounded-lg shadow-custom-white overflow-hidden">
            <thead className="bg-blue text-white">
              <tr>
                <th className="px-6 py-4 text-left hellix-font font-semibold">Visa</th>
                <th className="px-6 py-4 text-left hellix-font font-semibold">Best For</th>
                <th className="px-6 py-4 text-center hellix-font font-semibold">PR Pathway?</th>
              </tr>
            </thead>
            <tbody>
              {visaOptions.map((visa, index) => (
                <tr key={visa.id} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                  <td className="px-6 py-4 text-blue font-medium hellix-font">
                    Subclass {visa.id} ({visa.subtitle})
                  </td>
                  <td className="px-6 py-4 text-blue hellix-font">
                    {visa.bestFor}
                  </td>
                  <td className="px-6 py-4 text-center">
                    <span className={`px-3 py-1 rounded-full text-sm font-medium hellix-font ${
                      visa.prPathway 
                        ? 'bg-green-100 text-green-700' 
                        : 'bg-yellow-100 text-yellow-700'
                    }`}>
                      {visa.prPathway ? '✅ Yes' : '❌ No (temporary)'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Why Choose Immiget Global */}
      <div className="container max-w-1440px mx-auto px-4 py-6 lg:px-14">
        <div className="bg-gradient-to-r from-blue-50 to-green-50 rounded-lg p-6 lg:p-8">
          <h2 className="text-2xl lg:text-3xl text-blue font-bold hellix-font mb-6 text-center">
            Why Choose Immiget Global?
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[
              {
                icon: FaShieldAlt,
                title: "Expert NZ-AU Visa Specialists",
                description: "We know the unique requirements for Kiwis."
              },
              {
                icon: FaStar,
                title: "High Success Rate",
                description: "Proven track record with NZ visa applications."
              },
              {
                icon: FaClock,
                title: "Fast Processing Support",
                description: "Avoid delays with accurate submissions."
              },
              {
                icon: FaHome,
                title: "PR Pathway Guidance",
                description: "Help transitioning from SCV to permanent residency."
              }
            ].map((feature, index) => {
              const IconComponent = feature.icon;
              return (
                <div key={index} className="flex items-start gap-4 bg-white rounded-lg p-6 shadow-sm">
                  <div className="bg-blue text-white p-3 rounded-full flex-shrink-0">
                    <IconComponent className="text-xl" />
                  </div>
                  <div>
                    <h3 className="text-blue font-semibold hellix-font text-lg mb-2">
                      {feature.title}
                    </h3>
                    <p className="text-blue hellix-font">
                      {feature.description}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="text-center mt-8">
            <h3 className="text-xl text-blue font-bold hellix-font mb-4">
              Ready to Move to Australia?
            </h3>
            <p className="text-blue hellix-font text-lg mb-6">
              📞 Contact Immiget Global for a free NZ-AU visa assessment!
            </p>
            <button className="bg-blue text-white px-8 py-3 rounded-lg font-semibold hellix-font hover:bg-blue-700 transition-colors">
              Get Free Assessment
            </button>
          </div>
        </div>
      </div>

      {/* FAQs Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 lg:px-14">
        <div className="flex gap-2 mb-6">
          <div className="flex items-center">
            <img src={benifitIcon} alt="benefits" />
          </div>
          <h2 className="lg:text-[32px] text-2xl text-blue font-semibold hellix-font">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-lg shadow-custom-white overflow-hidden">
              <button
                onClick={() => setActiveFAQ(activeFAQ === index ? null : index)}
                className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
              >
                <span className="text-blue font-medium hellix-font text-lg">
                  ❓ {faq.question}
                </span>
                <span className={`text-blue text-xl transform transition-transform ${
                  activeFAQ === index ? 'rotate-180' : ''
                }`}>
                  ▼
                </span>
              </button>
              {activeFAQ === index && (
                <div className="px-6 pb-4 border-t bg-blue-50">
                  <p className="text-blue hellix-font pt-4">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Testimonials */}
      <Testimonials />

      {/* Contact Section */}
      <Contact />
    </div>
  );
};

export default NZAustraliaVisa;